<template>
  <div ref="Search"
       id="lin_Search">
    <el-row class="search"
            :gutter="20"
            type="flex"
            align="middle"
            justify="space-between">
      <div style="display: flex; justify-content: space-between">
        <div class="search-left"
             style="display: flex; justify-content: space-between"
             v-if="isquery">
          <el-form ref="searchForm"
                   :model="searchForm"
                   label-width="70px"
                   size="mini"
                   @submit.native.prevent>
            <template>
              <!-- 可插入关键字查询 -->
              <slot name="left"></slot>
              <div></div>
            </template>
          </el-form>
          <div style="width: 206px">
            <el-button size="mini"
                       type="primary"
                       plain
                       @click="handleSearch"
                       icon="el-icon-search">查询</el-button>
            <el-button :disabled="!advancedQuery"
                       v-if="advancedQuery"
                       size="mini"
                       type="primary"
                       plain
                       @click="heightSearch"
                       icon="el-icon-more">更多条件
              <i :class="hidden ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i></el-button>
          </div>
        </div>
      </div>
      <!-- 基本功能区 -->
      <div style="display: flex">
        <div class="functionBtn"
             v-if="functionBtn">
          <div>
            <slot name="center"></slot>
          </div>
        </div>
        <div class="operateBtn">
          <div>
            <el-button size="mini "
                       type="primary"
                       plain
                       @click="add"
                       icon="el-icon-plus"
                       :disabled="!isAdd || !verifyPermission('Add')"
                       v-if="showAdd">新增</el-button>
            <!-- <el-button
              size="mini "
              type="primary"
              plain
              disabled
              icon="el-icon-refresh"
              >恢复</el-button
            > -->
            <el-button size="mini "
                       type="primary"
                       plain
                       :disabled="!isDel || !verifyPermission('Delete')"
                       @click="del"
                       v-if="showDel"
                       icon="el-icon-delete">删除</el-button>
            <el-button type="primary"
                       plain
                       size="mini "
                       @click="sort"
                       icon="el-icon-refresh-right"
                       :disabled="!isSort || !verifyPermission('Update')"
                       v-if="showSort">更新排序</el-button>
            <el-button size="mini"
                       @click="dialogVisible = true"
                       icon="el-icon-s-grid"
                       :disabled="grid"></el-button>
          </div>
        </div>
      </div>
    </el-row>

    <!-- 高级查询区 -->
    <div class="advancedQuery"
         ref="advancedQuery"
         v-if="hidden">
      <el-row :gutter="20">
        <el-form ref="searchForm"
                 :model="searchForm"
                 label-width="70px"
                 size="mini">
          <slot name="advancedQuery"></slot>
        </el-form>
      </el-row>
    </div>
    <!-- 表格设置区 -->
    <el-dialog title="表格设置"
               :visible.sync="dialogVisible"
               width="30%"
               :before-close="handleClose">
      <div class="setTable">
        <!-- <div class="sort">
          <div class="sort-left">排序设置:</div>
          <div class="sort-right">
            <el-radio v-model="radio" label="true">当前页排序</el-radio>
            <el-radio v-model="radio" label="custom">全部页排序</el-radio>
          </div>
        </div> -->
        <div class="container">
          <div class="view-column view-column-title">
            <div class="view-column-title">列的设置:</div>
            <div class="view-column-index">#</div>
            <div class="view-column-left">列名</div>
            <div class="view-column-right">是否显示</div>
          </div>

          <div class="view-column"
               v-for="(item, i) in checkList"
               :key="i">
            <div class="view-column-title"></div>
            <div class="view-column-index">{{ i + 1 }}</div>
            <div class="view-column-left">
              {{ item.label }}
              <div style="margin-top: 10px"
                   v-for="(child, i) in item.children"
                   :key="i">
                {{ child.label }}
              </div>
            </div>
            <div class="view-column-right">
              <el-checkbox @change="changeCheckbox($event, item)"
                           v-model="item.flag"></el-checkbox>
              <div style="margin-top: 10px"
                   v-for="(child, i) in item.children"
                   :key="i">
                <el-checkbox @change="changeCheckbox($event, item)"
                             v-model="child.flag"></el-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <div style="text-align: center">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary"
                     @click="saveSet">确 定</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { verifyPermissionMinix } from "@/utils/mixin";
export default {
  props: {
    width: {
      type: String,
      default: "460px",
    },
    searchName: String,
    tableData: {
      type: Array,
    },
    config: Array,
    //更新排序配置
    sortPara: {
      type: Object,
    },
    mydel: {
      default: false,
      type: Boolean,
    },
    //批量删除配置
    delPara: {
      type: Object,
    },
    //是否有查询
    isquery: {
      default: true,
      type: Boolean,
    },
    grid: {
      default: false,
      type: Boolean,
    },
    // 是否高级查询
    advancedQuery: {
      default: true,
      type: Boolean,
    },
    //是否有基本功能区
    functionBtn: {
      default: false,
      type: Boolean,
    },
    bodyScaleFlag: {
      default: false,
      type: Boolean,
    },
    //是否有两层父组件
    twoParent: {
      type: Boolean,
    },
    // 是否排序
    isSort: {
      default: true,
      type: Boolean,
    },
    showSort: {
      default: true,
      type: Boolean,
    },
    // 是否有删除
    isDel: {
      default: true,
      type: Boolean,
    },
    // 是否有删除
    showDel: {
      default: true,
      type: Boolean,
    },
    // 是否有增加
    isAdd: {
      default: true,
      type: Boolean,
    },
    // 是否有增加
    showAdd: {
      default: true,
      type: Boolean,
    },
    // 表格规则
    tableConfig: {
      type: Array,
    },
    //表格存储名字
    tableName: {
      type: String,
    },
    //类名字名字
    pageNmae: {
      default: "page",
      type: String,
    },
    //扣项
    deduction: {
      default: "299px",
      type: String,
    },
  },
  mixins: [verifyPermissionMinix],
  data () {
    return {
      radio: "true",
      searchForm: {},
      hidden: false,
      height: "",
      dialogVisible: false,
      checkList: [],
      navHeight: "",
    };
  },
  mounted () {
    let _this = this;

    this.getHeight(this.pageNmae, this.deduction);
    //初始化获取列隐藏的本地存储或者传的值
    if (localStorage.getItem(this.tableName)) {
      this.checkList = JSON.parse(localStorage.getItem(this.tableName)).slice(
        0,
        -1
      );
      this.radio = JSON.parse(localStorage.getItem(this.tableName)).slice(
        -1
      )[0];
    } else if (this.tableConfig) {
      this.checkList = JSON.parse(JSON.stringify(this.tableConfig));
    }
    if (this.bodyScaleFlag) {
      this.$nextTick(() => {
        this.bodyScale();
      });
    }
    this.$nextTick(() => {
      window.onresize = () => {
        _this.getHeight(this.pageNmae, this.deduction);
        if (this.bodyScaleFlag) {
          this.bodyScale();
        }
      };
    });
  },
  methods: {
    bodyScale () {
      //获取当前分辨率下的可是区域宽度
      var devicewidth = document.documentElement.clientWidth;
      var scale = devicewidth / 1920; // 分母——设计稿的尺寸
      document.getElementById("lin_Search").style.zoom = scale; //放大缩小相应倍数

    },
    // 取消
    cancel () {
      this.dialogVisible = false;
      if (JSON.parse(localStorage.getItem(this.tableName))) {
        this.checkList = JSON.parse(localStorage.getItem(this.tableName));
        this.checkList.pop();
      }
      this.radio = "true";
    },
    // 设置列复合表头里的多选逻辑
    changeCheckbox (event, item) {
      let i = 0;
      if (item.children) {
        if (item.flag == false) {
          item.children.forEach((element) => {
            element.flag = false;
          });
        } else if (event == true) {
          item.children.forEach((element) => {
            element.flag = true;
          });
        }
        item.children.forEach((element) => {
          if (element.flag == true) {
            i++;
          }
        });
        if (i == 0) {
          item.flag = false;
        }
      }
    },
    //保存设置
    saveSet () {
      this.dialogVisible = false;
      //把排序规则放进数组一起本地存储
      this.checkList.push(this.radio);
      // 设置本地存储
      localStorage.setItem(this.tableName, JSON.stringify(this.checkList));
      //删除本地存储里面排序的影响
      this.checkList.pop();
      this.$emit("saveSet", this.checkList, this.radio);
    },
    //关闭
    handleClose (done) {
      done();
    },
    //新增
    add () {
      this.$emit("add");
    },
    //排序
    sort () {
      let arr = [];
      let obj = {};
      this.sortPara.data.forEach((element) => {
        if (element.add == "1") {
          obj.Id = element.id;
          obj.sort = element.sort;
          arr.push(obj);
          obj = {};
        }
      });
      this.$api[this.sortPara.controller]
      [this.sortPara.action](JSON.stringify(arr))
        .then((res) => {
          this.$parent[this.sortPara.callback]();

          this.$message.success("更新成功");
        });
    },
    //批量删除
    del () {
      if (this.delPara.data.length <= 0) {
        return this.$message.warning("请至少选择一条数据");
      }
      this.$confirm("是否删除当前选定记录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("BatchDelete");
          if (this.mydel) {
            return;
          }
          let sendData = this.delPara.data;
          this.$api[this.delPara.controller]
          [this.delPara.action](sendData)
            .then((res) => {
              if (res.error === false) {
                this.$message.success("删除成功");
                if (this.twoParent) {
                  this.$parent.$parent[this.delPara.callback]();
                } else {
                  this.$parent[this.delPara.callback]();
                }
              } else {
                this.$message.error(res.msg);
              }
            });
        })
        .catch(() => { });
    },
    // 计算表格的高度(需按照实际修改)
    getHeight (pageNmae = "page", deduction = "299px") {
      var tableHeight = 0;
      this.$nextTick(() => {
        if (
          document.getElementsByClassName("el-pagination")[0] &&
          document.getElementsByClassName(pageNmae)[0]
        ) {
          document
            .getElementsByClassName(pageNmae)[0]
            .style.setProperty(
              "height",
              `calc(100vh - ${deduction}`,
              "important"
            );
          let pageHeight =
            document.getElementsByClassName(pageNmae)[0].clientHeight;
          let searchHeight = this.$refs.advancedQuery
            ? this.$refs.advancedQuery.offsetHeight - 40
            : 0;
          let paginationHeight =
            document.getElementsByClassName("el-pagination")[0].clientHeight;
          tableHeight = pageHeight - 35 - paginationHeight - searchHeight;
          this.height = tableHeight;
          this.$emit("getHeight", tableHeight + "px");
          document
            .getElementsByClassName(pageNmae)[0]
            .style.setProperty(
              "height",
              `calc(100vh - ${deduction} - ${searchHeight}px)`,
              "important"
            );
        } else if (document.getElementsByClassName(pageNmae)[0]) {

          let searchHeight = this.$refs.advancedQuery ? this.$refs.advancedQuery.offsetHeight : 0;
          tableHeight =
            document.getElementsByClassName(pageNmae)[0].clientHeight -
            35 -
            searchHeight;
          this.$emit("getHeight", tableHeight + "px");
        }
      });
    },
    //查询
    handleSearch () {
      console.log(1);
      if (
        this.$parent.$refs.pagination ||
        this.$parent.$parent.$refs.pagination
      ) {
        if (this.twoParent) {
          this.$parent.$parent.$refs.pagination.currentPage = 1;
          this.$parent.$parent.$refs.pagination.pageSize = 20;
          this.$parent.$parent[this.searchName]();
        } else {
          this.$parent.$refs.pagination.currentPage = 1;
          this.$parent.$refs.pagination.pageSize = 20;
          this.$parent[this.searchName]();
        }
      } else {
        this.$parent[this.searchName]();
      }
    },
    //隐藏和显示高级查询
    heightSearch () {
      this.hidden = !this.hidden;
      this.getHeight();
    },
  },
  watch: {
    // 当一个页面两个表格切换时需要改变数据
    tableConfig: {
      handler (n, o) {
        this.checkList = JSON.parse(JSON.stringify(this.tableConfig));
        this.$forceUpdate();
      },
    },
    "$store.state.navHeight": {
      handler: function (newVal, oldVal) {
        this.navHeight = newVal;
        this.getHeight();
      },
    },
  },
};
</script>

<style lang='less'>
#lin_Search {
  // width: 100%;
  box-sizing: border-box;
  position: relative;
  padding: 0;
  .el-form-item--mini.el-form-item {
    margin-bottom: 0;
  }
  .search {
    margin-left: 0px !important;
    margin-right: 0px !important;
    position: relative;
    z-index: 1000;
    height: 70px;
    margin-bottom: 20px;
    box-shadow: 1px 6px 13px 0px #d0d0d0;
    border-radius: 25px;
    background-color: #fff;
  }

  .advancedQuery {
    // top: 55px;
    // position: absolute;
    // z-index: 99;
    margin-top: -55px;
    margin-bottom: 15px;
    width: 100%;
    // height: 42px;
    background-color: #f5f7f8;
    box-shadow: 1px 6px 13px 0px #d0d0d0;
    border-radius: 0 0 25px 25px;
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding-top: 30px;
    padding-bottom: 18px;
    .el-form-item {
      margin-bottom: 0px !important;
      padding: 5px !important;
    }
  }

  .operateBtn {
    display: flex;
    justify-content: flex-end;
    border-left: 1px solid #dcdfe2;
    div {
      box-sizing: border-box;

      padding: 10px 15px;
      border-radius: 10px;
    }
  }

  .functionBtn {
    box-sizing: border-box;
    margin-right: 16px;

    > div {
      box-sizing: border-box;

      padding: 10px 15px;
      border-radius: 10px;
    }
  }

  .search-left {
    box-sizing: border-box;

    padding: 10px 5px;
    border-radius: 10px;
  }

  .setTable {
    width: 100%;
    height: 400px;
    overflow-y: scroll;

    .el-checkbox-group {
      font-size: 14px;
    }

    .sort {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      border: 1px solid #dfdddd9c;
      padding: 5px;
      padding-left: 15px;
      margin-bottom: 10px;
      border-radius: 5px;

      .sort-left {
        font-size: 15px;
        line-height: 40px;
      }

      .sort-right {
        height: 100%;
        line-height: 29px;
        margin-left: 10px;
      }
    }

    .container {
      border: 1px solid #dfdddd9c;
      padding: 5px;
      border-radius: 5px;
    }

    .view-column {
      cursor: pointer;
      display: flex;
      padding: 10px;
      border-bottom: 1px solid #f3f3f3;

      .view-column-title {
        width: 70px;
      }

      .view-column-index {
        width: 50px;
      }

      .view-column-left {
        width: 120px;
        padding: 0 10px;
      }

      .view-column-right {
        flex: 1;
      }
    }
  }
}
</style>